import React from 'react';
import { ProductCompareUnion} from "../interfaces";

const tdStyle= {
    width: '20%',
    verticalAlign: 'top',
    height: 'inherit,'
};

const removeIconStyle = {
    right: '13px',
    top: '5px',
};

interface ITR_ROW {
    productCompareUnionList?: ProductCompareUnion[];
    propName?: string
    propTitle: string
    emptyServers: number
}

const TR_ROW = (props: ITR_ROW) => {

    const productCompareUnionList  = props.productCompareUnionList;
    const propName  = props.propName;
    const propTitle  = props.propTitle;
    const emptyServers = props.emptyServers;
    //const dispatch = useAppDispatch();

    //const pcWrap = useAppSelector(store => store.pcWrap);
    //const documentIDs = useAppSelector(store => store.documentIDs);
    const read_prop = (obj: any, prop:string) => {
        return obj[prop];
    }
    return (
        <tr key={`tr-${propName}`}>
            {!propName && <td className="py-2 font-bold">{propTitle}</td>}
            {propName && <td className="py-2">{propTitle}</td>}

            { productCompareUnionList!= null && propName != null &&
                productCompareUnionList?.map((item, i) => {
                    return (
                        <td key={ `td-${propName}-${ i }` } className="border-l border-t text-center">
                            { read_prop(item.productCompareItem,propName) }
                        </td>
                    )
                })
            }

            {
                emptyServers > 0 &&
                <>{[...Array(emptyServers)].map((_el, index) => {
                    return <td key={ `empty-included-${ index }` }></td>
                })}</>
            }
        </tr>
    )
};

export default TR_ROW;